import { render, staticRenderFns } from "./AceitarConvite.vue?vue&type=template&id=0f68e53a&scoped=true"
import script from "./AceitarConvite.vue?vue&type=script&lang=js"
export * from "./AceitarConvite.vue?vue&type=script&lang=js"
import style0 from "./AceitarConvite.vue?vue&type=style&index=0&id=0f68e53a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f68e53a",
  null
  
)

export default component.exports